import React, { useEffect, useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  TextField,
  Grid,
  Button,
  MenuItem,
  Alert,
  FormControlLabel,
  FormControl,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { validateEcommercePlaceAccount } from "../../../../utils/validation";
import useAlert from "../../../../hooks/useAlert";
import {
  addEcommercePlacesAccount,
  getEcommercePlaces,
  getEcommercePlacesAccounts,
  updateEcommercePlacesAccount,
} from "../../../../redux/actions/ecommercePlaceActions";
import { IoMdSave } from "react-icons/io";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import outWardService from "../../../../services/outWardService";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`EcommercePlace-tabpanel-${index}`}
      aria-labelledby={`EcommercePlace-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
const ECOMMERCE_FIELDS = {
  woocommerce: [
    { id: "WebSite", label: "Web Site", valueId: "WebSite", type: "key" },
    {
      id: "ConsumerKey",
      label: "ConsumerKey",
      valueId: "ConsumerKey",
      type: "key",
    },
    { id: "SecretKey", label: "SecretKey", valueId: "SecretKey", type: "key" },
  ],
  shopier: [
    { id: "ApiKey", label: "Api Key", valueId: "ApiKey", type: "key" },
    {
      id: "Currency",
      label: "Para Birimi",
      valueId: "Currency",
      type: "settings",
      placeholder: "TRY",
    },
    {
      id: "PreparationTime",
      label: "Hazırlık Süresi",
      valueId: "PreparationTime",
      type: "settings",
    },
    {
      id: "ProductType",
      label: "Ürün tipi",
      valueId: "ProductType",
      type: "settings",
      impuType: "ProductType",
    },
    {
      id: "DeliveryType",
      label: "Teslimat Türü",
      valueId: "DeliveryType",
      type: "settings",
      impuType: "DeliveryType",
    },
    {
      id: "ShippingPrice",
      label: "Kargo ücreti",
      valueId: "ShippingPrice",
      type: "settings",
    },
  ],
  opencart: [
    { id: "ApiKey", label: "Api Key", valueId: "ApiKey", type: "key" },
    { id: "WebSite", label: "Web Site", valueId: "WebSite", type: "key" },
    {
      id: "UserName",
      label: "Kullanıcı Adı",
      valueId: "UserName",
      type: "key",
    },
    { id: "Weight", label: "Ağırlık", valueId: "Weight", type: "settings" },
  ],
  ikas: [
    { id: "StoreName", label: "Mağza İsmi", valueId: "StoreName", type: "key" },
    { id: "ClientId", label: "ClientId", valueId: "ClientId", type: "key" },
    {
      id: "ClientSecret",
      label: "Client Secret",
      valueId: "ClientSecret",
      type: "key",
    },
    {
      id: "Currency",
      label: "Para Birimi",
      valueId: "Currency",
      type: "settings",
      placeholder: "TRY",
    },
    { id: "SiteId", label: "Site Kimliği", valueId: "SiteId", type: "key" },
    {
      id: "LocationId",
      label: "Lokasyon ID",
      valueId: "LocationId",
      type: "key",
    },
    {
      id: "ProductType",
      label: "Ürün tipi",
      valueId: "ProductType",
      type: "settings",
      impuType: "ProductType",
    },
  ],
  shopify: [
    { id: "ApiKey", label: "Api Key", valueId: "ApiKey", type: "key" },
    { id: "WebSite", label: "Web Site", valueId: "WebSite", type: "key" },
    {
      id: "WeightUnit",
      label: "Ağırlık tipi",
      valueId: "WeightUnit",
      type: "settings",
    },
    { id: "Weight", label: "Ağırlık", valueId: "Weight", type: "settings" },

    //{ id: 'PreparationTime', label: 'Hazırlık Zamanı', valueId: 'PreparationTime', type: 'settings' },
    {
      id: "Taxable",
      label: "Vergilendirilebilir",
      valueId: "Taxable",
      type: "settings",
    },
    { id: "Vendor", label: "Satıcı", valueId: "Vendor", type: "settings" },

    {
      id: "Currency",
      label: "Para Birimi",
      valueId: "Currency",
      type: "settings",
      placeholder: "TRY",
    },
    {
      id: "LocationId",
      label: "Lokasyon",
      valueId: "LocationId",
      type: "settings",
    },
  ],

  ticimax: [
    {
      id: "AuthorizeCode",
      label: "Authorize Code",
      valueId: "AuthorizeCode",
      type: "key",
    },
    { id: "WebUrl", label: "Web Site", valueId: "WebUrl", type: "key" },
    { id: "Desi", label: "Desi", valueId: "Desi", type: "settings" },
    {
      id: "CargoFee",
      label: "Kargo ücreti",
      valueId: "CargoFee",
      type: "settings",
    },
    {
      id: "SupplierId",
      label: "SupplierId",
      valueId: "SupplierId",
      type: "key",
    },
    { id: "BrandId", label: "BrandId", valueId: "BrandId", type: "key" },
    {
      id: "Currency",
      label: "Para Birimi",
      valueId: "Currency",
      type: "settings",
      placeholder: "TRY",
    },
    {
      id: "FreeShipping",
      label: "Ücretsiz kargo",
      valueId: "FreeShipping",
      type: "settings",
      inputType: "checkbox",
    },
  ],

  wix: [
    { id: "Token", label: "Token", valueId: "Token", type: "key" },
    { id: "SiteId", label: "Site Kimliği", valueId: "SiteId", type: "key" },
    {
      id: "Currency",
      label: "Para Birimi",
      valueId: "Currency",
      type: "settings",
      placeholder: "TRY",
    },
    {
      id: "ProductType",
      label: "Ürün tipi",
      valueId: "ProductType",
      type: "settings",
      impuType: "ProductType",
    },
    { id: "Weight", label: "Ağırlık", valueId: "Weight", type: "settings" },
  ],
};

const DEFAULT_FIELDS = [
  { id: "ApiKey", label: "Api Key", valueId: "ApiKey" },
  { id: "ApiSecret", label: "Api Secret", valueId: "ApiSecret" },
];

const DeliveryType = [
  { id: "buyerPays", name: "Alıcı Öder" },
  { id: "sellerPays", name: "Satıcı Öder" },
];
const ProductTypeIkas = [
  { id: "PHYSICAL", name: "Fiziksel" },
  { id: "DIGITAL", name: "Dijital" },
];
const ProductType = [
  { id: "physical", name: "Fiziksel" },
  { id: "digital", name: "Dijital" },
];

const Currency = [
  { id: "EUR_BID", name: "EUR_BID" },
  { id: "EUR", name: "Euro" },
  { id: "GBP_BID", name: "GBP_BID" },
  { id: "GBP", name: "British Pound" },
  { id: "USD_BID", name: "USD_BID" },
  { id: "USD", name: "US Dollar" },
  { id: "TRY", name: "TRY" },
];
const CurrencyTicimax = [
  { id: "1", name: "TL" },
  { id: "4", name: "CHF" },
  { id: "3", name: "EURO" },
  { id: "2", name: "USD" },
];
const CurrencyIkas = [
  { id: "TRY", name: "Türk Lirası" }, // Türk Lirası
  { id: "USD", name: "Amerikan Doları" }, // Amerikan Doları
  { id: "EUR", name: "Euro" }, // Euro
  { id: "GBP", name: "İngiliz Sterlini" }, // İngiliz Sterlini
  { id: "JPY", name: "Japon Yeni" }, // Japon Yeni
  { id: "CHF", name: "İsviçre Frangı" }, // İsviçre Frangı
  { id: "CAD", name: "Kanada Doları" }, // Kanada Doları
  { id: "AUD", name: "Avustralya Doları" }, // Avustralya Doları
  { id: "RUB", name: "Rus Rublesi" }, // Rus Rublesi
  { id: "CNY", name: "Çin Yuanı" }, // Çin Yuanı
  { id: "SAR", name: "Suudi Arabistan Riyali" }, // Suudi Arabistan Riyali
  { id: "AED", name: "Birleşik Arap Emirlikleri Dirhemi" }, // BAE Dirhemi
  { id: "INR", name: "Hint Rupisi" }, // Hint Rupisi
  { id: "KRW", name: "Güney Kore Wonu" }, // Güney Kore Wonu
  { id: "BRL", name: "Brezilya Reali" }, // Brezilya Reali
  { id: "ZAR", name: "Güney Afrika Randı" }, // Güney Afrika Randı
  { id: "SEK", name: "İsveç Kronu" }, // İsveç Kronu
  { id: "NZD", name: "Yeni Zelanda Doları" }, // Yeni Zelanda Doları
  { id: "MXN", name: "Meksika Pesosu" }, // Meksika Pesosu
  { id: "SGD", name: "Singapur Doları" }, // Singapur Doları
  { id: "HKD", name: "Hong Kong Doları" }, // Hong Kong Doları
];

const EcommercePlace = ({
  market,
  appUserId,
  formErrors,
  setFormErrors,
  showSuccessEcommercePlaceAccountAdd,
  showErrorAlertEcommercePlaceAccountAdd,
  showSuccessEcommercePlaceAccountUpdate,
  showErrorAlertEcommercePlaceAccountUpdate,
  getEcommercePlace,
  getEcommercePlaceAccounts,
  data,
  token,
  setLoading,
}) => {
  const [locations, setLocations] = useState([]);
  const hasExistingData =
    data &&
    Array.isArray(data) &&
    data.some((item) => item.ecommercePlaceId === market.id);
  const [formData, setFormData] = useState(() => {
    const initialData = {};
    if (data && Array.isArray(data)) {
      const marketSpecificData = data.filter(
        (item) => item.ecommercePlaceId === market.id
      );
      marketSpecificData.forEach((item) => {
        const fields =
          ECOMMERCE_FIELDS[market.name.toLowerCase()] || DEFAULT_FIELDS;

        const field = fields.find((f) => f.valueId === item.valueId);
        if (field) {
          initialData[field.id] = item.value;
        }
      });
    }
    return initialData;
  });

  const handleInputChange = (fieldId, value) => {
    setFormData((prev) => ({
      ...prev,
      [fieldId]: value,
    }));
  };

  const dispatch = useDispatch();

  const addEcommerceAccount = async (event) => {
    event.preventDefault();
    const fields =
      ECOMMERCE_FIELDS[market.name.toLowerCase()] || DEFAULT_FIELDS;
    const EcommercePlaceData = fields.map((field) => ({
      ecommercePlaceId: market.id,
      valueId: field.valueId,
      value: formData[field.id] || "",
      appUserId: appUserId,
      type: field.type,
    }));

    const errors = validateEcommercePlaceAccount(EcommercePlaceData);
    setFormErrors(errors);
    const hasErrors = errors.some((error) => Object.keys(error).length > 0);

    if (!hasErrors) {
      try {
        setLoading(true);
        const response = await dispatch(
          addEcommercePlacesAccount({ EcommercePlaceData }, token)
        );
        getEcommercePlace();
        getEcommercePlaceAccounts();
        setLoading(false);
        showSuccessEcommercePlaceAccountAdd();
      } catch (err) {
        setLoading(false);
        showErrorAlertEcommercePlaceAccountAdd();
        console.log("Market ayarları eklenemedi", err);
      }
    }
  };

  const updateEcommerceAccount = async (event) => {
    event.preventDefault();

    const fields =
      ECOMMERCE_FIELDS[market.name.toLowerCase()] || DEFAULT_FIELDS;

    const EcommercePlaceData = fields.map((field) => {
      const matchingData = data.find(
        (d) => d.ecommercePlaceId === market.id && d.valueId === field.valueId
      );

      return {
        id: matchingData?.id || 0,
        ecommercePlaceId: market.id,
        valueId: field.valueId,
        value: formData[field.id] || "",
        appUserId: appUserId,
        type: field.type,
      };
    });

    const errors = validateEcommercePlaceAccount(EcommercePlaceData);
    setFormErrors(errors);
    const hasErrors = errors.some((error) => Object.keys(error).length > 0);

    if (!hasErrors) {
      try {
        console.log("EcommercePlaceData", EcommercePlaceData);
        setLoading(true);
        const response = await dispatch(
          updateEcommercePlacesAccount({ EcommercePlaceData }, token)
        );
        showSuccessEcommercePlaceAccountUpdate();
        getEcommercePlace();
        getEcommercePlaceAccounts();
        setLoading(false);
      } catch (err) {
        setLoading(false);
        showErrorAlertEcommercePlaceAccountUpdate();
        console.log("Market ayarları güncellenemedi", err);
      }
    }
  };
  const renderFields = () => {
    const fields =
      ECOMMERCE_FIELDS[market.name.toLowerCase()] || DEFAULT_FIELDS;
    const keyFields = fields.filter((field) => field.type === "key");
    const settingsFields = fields.filter((field) => field.type === "settings");

    return (
      <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
        {keyFields.length > 0 && (
          <>
            <Grid item xs={12} style={{ textAlign: "left" }}>
              <Typography
                variant="h6"
                sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}
              >
                Bağlantı Ayarları
              </Typography>
            </Grid>
            {keyFields.map((field, index) => (
              <Grid item xs={12} sm={6} md={4} key={field.id}>
                <TextField
                  size="small"
                  fullWidth
                  label={field.label}
                  value={formData[field.id] || ""}
                  onChange={(e) => handleInputChange(field.id, e.target.value)}
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": {
                      fontSize: { xs: "0.875rem", sm: "1rem" },
                    },
                  }}
                  error={formErrors?.find(
                    (k) =>
                      k.type == "key" &&
                      k.ecommercePlaceId == market.id &&
                      k.valueId == field?.id
                  )}
                  helperText={
                    formErrors?.find(
                      (k) =>
                        k.type == "key" &&
                        k.ecommercePlaceId == market.id &&
                        k.valueId == field?.id
                    )?.value || ""
                  }
                />
              </Grid>
            ))}
          </>
        )}

        {/* Genel Ayarlar */}
        {settingsFields.length > 0 && (
          <>
            <Grid item xs={12} style={{ textAlign: "left" }}>
              <Typography
                variant="h6"
                sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}
              >
                Genel Ayarlar
              </Typography>
            </Grid>

            {settingsFields.map((field, index) => (
              <Grid item xs={12} sm={6} md={4} key={field.id}>
                {field.inputType === "checkbox" ? (
                  <FormControl fullWidth>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData[field.id] === "true"}
                          onChange={(e) =>
                            handleInputChange(
                              field.id,
                              e.target.checked.toString()
                            )
                          }
                          color="primary"
                        />
                      }
                      label={field.label}
                    />
                  </FormControl>
                ) : field.id === "Currency" && market.name === "Ticimax" ? (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.ecommercePlaceId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.ecommercePlaceId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                  >
                    {CurrencyTicimax.map((x) => (
                      <MenuItem key={x.id} value={x.id}>
                        {x.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : field.id == "Currency" && market.name == "Ikas" ? (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.ecommercePlaceId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.ecommercePlaceId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                  >
                    {CurrencyIkas.map((x) => (
                      <MenuItem key={x.id} value={x.id}>
                        {x.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : field.id == "Currency" ? (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.ecommercePlaceId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.ecommercePlaceId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                  >
                    {Currency.map((x) => (
                      <MenuItem key={x.id} value={x.id}>
                        {x.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : field.id == "LocationId" ? (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.ecommercePlaceId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.ecommercePlaceId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                  >
                    {locations.map((x) => (
                      <MenuItem key={x.id} value={x.id.toString()}>
                        {x.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : (
                  <TextField
                    select={
                      field.impuType === "DeliveryType" ||
                      field.impuType === "ProductType"
                    }
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.ecommercePlaceId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.ecommercePlaceId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                    placeholder={field?.placeholder}
                  >
                    {field.impuType === "DeliveryType" &&
                      DeliveryType.map((x) => (
                        <MenuItem key={x.id} value={x.id}>
                          {x.name}
                        </MenuItem>
                      ))}

                    {field.impuType === "ProductType" && market.name == "Ikas"
                      ? ProductTypeIkas.map((x) => (
                          <MenuItem key={x.id} value={x.id}>
                            {x.name}
                          </MenuItem>
                        ))
                      : ProductType.map((x) => (
                          <MenuItem key={x.id} value={x.id}>
                            {x.name}
                          </MenuItem>
                        ))}
                  </TextField>
                )}
              </Grid>
            ))}

            {market.name == "OpenCart" ? (
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
                >
                  Opencart sisteminden 207.38.89.173 Ip adresine izin
                  verilmelidir.
                </Alert>
              </Grid>
            ) : market.name == "Wix" ? (
              <Grid item xs={12} style={{ textAlign: "left" }}>
                <Alert severity="info">
                  Not: Mevcut bir sitenin site kimliği tarayıcınızdaki site
                  URL'sinden elde edilebilir. Örneğin, site kimliği bu URL'nin
                  '/dashboard/' kısmından sonra görünür. Url'si
                  https://manage.wix.com/dashboard/cd1c990c-8678-4f03-8235-83d6b58eb4d1/setup
                  olan sitenin site kimliği:
                  cd1c990c-8678-4f03-8235-83d6b58eb4d1 dir.
                </Alert>
              </Grid>
            ) : market.name == "Ikas" ? (
              <Grid item xs={12} style={{ textAlign: "left" }}>
                <Alert severity="info">
                  Not: Mevcut bir sitenin site kimliği tarayıcınızdaki site
                  URL'sinden elde edilebilir. Örneğin, Url'si
                  https://netsimbutik.myikas.com/admin/storefront/489a07b7-b799-4cf0-92eb-7dba64ccfd24/my-themes
                  olan sitenin site kimliği:
                  489a07b7-b799-4cf0-92eb-7dba64ccfd24 dir.
                </Alert>
                <Box mt={1}>
                  <Alert severity="info">
                    Not: Lokasyon Id için ayarlardan stock lokasyonu bölümünden
                    lokasyon detayına gidip url deki parametreyi almalısınız.
                    Örneğin, Url'si
                    https://netsimbutik.myikas.com/admin/settings/stock-location/edit/99384dd2-31e0-431b-9387-42e4abdb8873
                    olan sitenin lokasyon ıd si:
                    99384dd2-31e0-431b-9387-42e4abdb8873 tür.
                  </Alert>
                </Box>
                <Box mt={1}>
                  <Alert severity="info">
                    Not: ClientId ve Client Secret için ikas üzerinden özel
                    uygulama oluşturmanız gerekmektedir.
                  </Alert>
                </Box>
              </Grid>
            ) : null}
            {market.name == "Shopier" ? (
              <Grid item xs={12} style={{ textAlign: "left" }}>
                <Alert severity="info">
                  {
                    "Hesap yönetimi -> kişisel erişim anahtarı sekmesinden anahtar oluşturabilirsiniz."
                  }
                </Alert>
              </Grid>
            ) : null}
            {market.name == "Shopify" ? (
              <Grid item xs={12} style={{ textAlign: "left" }}>
                 <Box mt={1}>
                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Alert severity="info">
                      {
                        "Not:Lokasyon parametresi api key ve secret değeri girildikten sonra tekrar seçilmeli !"
                      }
                    </Alert>
                  </Grid>
                </Box>
                <Box mt={1}>
                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Alert severity="info">
                      {
                        "Not:Vergilendirilebilir alanına ürün vergilendirilebilir ise True,değil ise False yazınız."
                      }
                    </Alert>
                  </Grid>
                </Box>
                <Box mt={1}>
                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Alert severity="info">
                      {
                        "Ayarlar -> Uygulamalar ve satış kanalları -> api kimlik bilgileri sekmesinden erişebilirsini"
                      }
                    </Alert>
                  </Grid>
                </Box>
                <Box mt={1}>
                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Alert severity="info">
                      {
                        "Not: Web site alanını admin panelinin sonunda ki değer ile oluşturmanız gerekli. Örnek olarak https://admin.shopify.com/store/s2jvk6-29 bu admin panelinin web sitesi şu şekilde olmalı https://s2jvk6-29.myshopify.com/"
                      }
                    </Alert>
                  </Grid>
                </Box>
              </Grid>
            ) : null}
            {market.name == "WooCommerce" ? (
              <Grid item xs={12} style={{ textAlign: "left" }}>
                <Alert severity="info">
                  {
                    "ayarlar kısmından -> gelişmiş sekmesi -> rest api klısmından anahtar oluşturabilirsiniz"
                  }
                </Alert>
              </Grid>
            ) : null}
            {market.name == "Wix" ? (
              <Grid item xs={12} style={{ textAlign: "left" }}>
                <Alert severity="info">
                  {
                    "hesap ayarları kısmından -> api anahtarları sayfasından api key oluşturabilirsiniz"
                  }
                </Alert>
              </Grid>
            ) : null}
            {market.name == "Ticimax" ? (
              <Grid item xs={12} style={{ textAlign: "left" }}>
                <Box mt={1}>
                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Alert severity="info">
                      {
                        "AuthorizeCode --> https://domain.com/Admin/YetkiKoduYonetimi.aspx sayfasındaki yetki kodu"
                      }
                    </Alert>
                  </Grid>
                </Box>
                <Box mt={1}>
                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Alert severity="info">
                      {
                        "SupplierID --> https://domain.com/Admin/TedarikciYonetimi.aspx sayfasındaki ID"
                      }
                    </Alert>
                  </Grid>
                </Box>
                <Box mt={1}>
                  <Grid item xs={12} style={{ textAlign: "left" }}>
                    <Alert severity="info">
                      {
                        "BrandID  --> https://domain.com/Admin/MarkaYonetimi.aspx sayfasındaki ID"
                      }
                    </Alert>
                  </Grid>
                </Box>
              </Grid>
            ) : null}
          </>
        )}
      </Grid>
    );
  };
  const createRequestBody = (selectedPlaceName) => {
    // e-Ticaret ayarları (manuel olarak tanımlanmış)
    const ecommercePlaceSettings = data
      .filter((account) => account.ecommercePlaceName === selectedPlaceName)
      .map((account) => ({
        id: 0,
        userId: account.userId,
        ecommercePlaceId: account.ecommercePlaceId || 0,
        ecommercePlaceName: account.ecommercePlaceName,
        valueId: account.valueId,
        value: account.value,
        createDate: new Date().toISOString(),
        updateDate: new Date().toISOString(),
        ia: true,
      }));
    return {
      userId: 0,
      ecommercePlaceSettings,
    };
  };
  useEffect(() => {
    if (market.name != "Shopify") return;
    const fetchLocations = async () => {
      try {
        const body = createRequestBody(market.name);
        const response = await outWardService.fetchLocation(market.name, body);
        setLocations(response.locations || []);
      } catch (error) {
        setLocations([{id:0,name:"Default"}]);
        console.error("Lokasyonlar alınırken hata oluştu:", error);
      }
    };

    fetchLocations();
  }, [market.name]);
  return (
    <form
      onSubmit={hasExistingData ? updateEcommerceAccount : addEcommerceAccount}
    >
      <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.5rem" } }}
          >
            {market.name} Ayarları
          </Typography>
        </Grid>
        {renderFields()}
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: { xs: "center", sm: "flex-end" },
            mt: { xs: 1, sm: 2, md: 3 },
          }}
        >
          <Button
            type="submit"
            variant="contained"
            startIcon={<IoMdSave />}
            sx={{
              borderRadius: 2,
              backgroundColor: "#1F1B45",
              color: "#FFFFFF",
              textTransform: "none",
              fontWeight: 500,
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              padding: { xs: "8px 16px", sm: "10px 20px" },
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: { xs: "100%", sm: "auto" },
              "&:hover": {
                backgroundColor: "#2C285A",
              },
            }}
          >
            Kaydet
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

const EcommercePlaceAccount = () => {
  const {
    showSuccessEcommercePlaceAccountAdd,
    showErrorAlertEcommercePlaceAccountAdd,
  } = useAlert();
  const {
    showSuccessEcommercePlaceAccountUpdate,
    showErrorAlertEcommercePlaceAccountUpdate,
  } = useAlert();
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const [formErrors, setFormErrors] = useState([]);
  const [value, setValue] = useState(0);
  const [formValues, setFormValues] = useState([]);
  const [data, setData] = useState();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const getEcommercePlace = async (token) => {
    try {
      const response = await dispatch(getEcommercePlaces(token));
      if (response.success) {
        setFormValues(response?.data);
      }
    } catch (err) {
      console.log("Marketler getirilemedi", err);
    }
  };
  const getEcommercePlaceAccounts = async () => {
    try {
      const response = await dispatch(
        getEcommercePlacesAccounts(authUserId, token)
      );

      if (response.success) {
        setData(response?.data);
      }
    } catch (err) {
      console.log("Marketler hesap bilgileri getirilemedi", err);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await getEcommercePlace();
      await getEcommercePlaceAccounts();
      setLoading(false);
    };

    fetchData();
  }, []);
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: { xs: "200px", sm: "300px", md: "400px" },
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (formValues.length > 0) {
    return (
      <Box
        sx={{
          width: "100%",
          minHeight: { xs: "300px", sm: "400px", md: "500px" },
          height: "auto",
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="EcommercePlace tabs"
            sx={{
              "& .MuiTab-root": {
                fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
                minWidth: { xs: "80px", sm: "100px", md: "120px" },
              },
            }}
          >
            {formValues.map((market) => (
              <Tab
                key={market.id}
                label={market.name}
                id={`EcommercePlace-tab-${market.id}`}
                aria-controls={`EcommercePlace-tab-${market.id}`}
              />
            ))}

            <Tab
              key={formValues.length}
              label={
                <span
                  style={{
                    fontSize: { xs: "24px", sm: "30px" },
                    fontWeight: "bold",
                  }}
                >
                  +
                </span>
              }
              id={`EcommercePlace-tab-${formValues.length}`}
              aria-controls={`EcommercePlace-tab-${formValues.length}`}
            />
          </Tabs>
        </Box>
        {formValues.map((market, index) => (
          <TabPanel key={market.id} value={value} index={index}>
            <EcommercePlace
              market={market}
              appUserId={authUserId}
              formErrors={formErrors}
              setFormErrors={setFormErrors}
              showSuccessEcommercePlaceAccountAdd={
                showSuccessEcommercePlaceAccountAdd
              }
              showErrorAlertEcommercePlaceAccountAdd={
                showErrorAlertEcommercePlaceAccountAdd
              }
              showSuccessEcommercePlaceAccountUpdate={
                showSuccessEcommercePlaceAccountUpdate
              }
              showErrorAlertEcommercePlaceAccountUpdate={
                showErrorAlertEcommercePlaceAccountUpdate
              }
              getEcommercePlace={getEcommercePlace}
              getEcommercePlaceAccounts={getEcommercePlaceAccounts}
              data={data}
              token={token}
              setLoading={setLoading}
            />
          </TabPanel>
        ))}
        <TabPanel
          key={formValues.length}
          value={value}
          index={formValues.length}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: 4,
            }}
          >
            <Alert severity="info" sx={{ width: "100%", marginBottom: 4 }}>
              Yeni bir E-Ticaret Platformu eklemek için aşağıdaki butona
              tıklayabilirsiniz.
            </Alert>
            <Button
              variant="contained"
              startIcon={<FaPlus />}
              onClick={() => (window.location.href = "/Application")}
            >
              Ekle
            </Button>
          </Box>
        </TabPanel>
      </Box>
    );
  } else {
    return (
      <Box
        sx={{
          width: "100%",
          minHeight: { xs: "300px", sm: "400px", md: "500px" },
          height: "auto",
        }}
      >
        <TabPanel value={0} index={0}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: { xs: 2, sm: 3, md: 4 },
            }}
          >
            <Alert
              severity="info"
              sx={{
                width: "100%",
                marginBottom: { xs: 2, sm: 3, md: 4 },
                fontSize: { xs: "0.875rem", sm: "1rem" },
              }}
            >
              Henüz hiç E-Ticaret Platformu eklenmemiş. Yeni bir E-Ticaret
              Platformu eklemek için aşağıdaki butona tıklayabilirsiniz.
            </Alert>
            <Button
              variant="contained"
              startIcon={<FaPlus />}
              onClick={() => (window.location.href = "/Application")}
              sx={{
                width: { xs: "100%", sm: "auto" },
                fontSize: { xs: "0.875rem", sm: "1rem" },
                padding: { xs: "8px 16px", sm: "10px 20px" },
              }}
            >
              Ekle
            </Button>
          </Box>
        </TabPanel>
      </Box>
    );
  }
};

export default EcommercePlaceAccount;
